import { Button } from "@/components/ui/baseUi/button"
import { cn } from "@/modules/lib/utils"
import { InformationAlertIcon } from "@images/svgIcons/informationAlertIcon"
import { word } from "@modules/core/utils/i18n"
import { useProgram } from "@modules/programs/hooks/usePrograms"
import { useProgramAthleteSubscription } from "@modules/programs/hooks/useProgramSubscription"
import { LoaderCircle } from "lucide-react"
import { Text } from "@/components/ui/baseUi/text"

type ProgramBundleDoubleSubscriptionInformationProps = {
  programId: string
  className?: string
} & React.ComponentProps<"div">

export function ProgramBundleDoubleSubscriptionInformation({
  programId,
  className,
  ...props
}: ProgramBundleDoubleSubscriptionInformationProps) {
  const { isUpdating: isUnsubscribing, unsubscribe } = useProgramAthleteSubscription(programId)
  const { data: program } = useProgram(programId)

  return (
    <div className={cn("card banner overflow-hidden rounded-2xl p-1", className)} {...props}>
      <div className="flex grow flex-row items-start justify-between gap-4 p-4">
        <div className="flex items-center justify-between rounded-4xl bg-primary-500 p-0">
          <InformationAlertIcon
            color="currentColor"
            backgroundColor="var(--primary-500)"
            className="text-textDefault-body"
          />
        </div>

        <div className="flex flex-col gap-4">
          <Text fontStyle="BL">
            {word("program.subscription.doubleSubscription.title", {
              programBundleName: program.programBundle?.programBundleName,
            })}
          </Text>

          <Button
            isLoading={isUnsubscribing}
            variant="primary"
            onClick={() => void unsubscribe()}
            disabled={isUnsubscribing}
          >
            {isUnsubscribing && <LoaderCircle className="animate-spin" />}
            {word("program.subscription.doubleSubscription.unsubscribeSingleProgram")}
          </Button>
        </div>
      </div>
    </div>
  )
}
